const cardsData = [
  {
    title: '热血漫入坑指南',
    desc: '从经典到新作，热血漫画的必追清单，最新漫画更新一网打尽。',
    tag: '追更指南',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20manga%20style%20illustration%20of%20energetic%20action%20scene%20with%20warm%20red%20and%20orange%20gradient%2C%20bold%20linework%20and%20speed%20lines%2C%20Japanese%20comic%20aesthetic%20with%20dynamic%20composition&width=600&height=400&seq=cards-shonen-01&orientation=landscape',
  },
  {
    title: '恋爱漫甜度排行',
    desc: '让人心跳加速的恋爱连载推荐，最新漫画更新糖分满满。',
    tag: '品类推荐',
    image: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20illustration%20with%20cherry%20blossom%20petals%20and%20warm%20pink%20amber%20tones%2C%20gentle%20artistic%20composition%2C%20Japanese%20shojo%20manga%20inspired%20aesthetic%20with%20dreamy%20atmosphere&width=600&height=400&seq=cards-romance-02&orientation=landscape',
  },
  {
    title: '悬疑漫烧脑推荐',
    desc: '层层反转的悬疑连载，烧脑推理停不下来，追更首选。',
    tag: '编辑精选',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20atmospheric%20illustration%20with%20dark%20warm%20amber%20lighting%20and%20shadowy%20composition%2C%20film%20noir%20inspired%20aesthetic%2C%20Japanese%20seinen%20manga%20style%20with%20dramatic%20contrast&width=600&height=400&seq=cards-mystery-03&orientation=landscape',
  },
  {
    title: '新连载抢先看',
    desc: '2025年最受期待的新连载漫画汇总，追更漫画从第一话开始。',
    tag: '新作速递',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20vibrant%20illustration%20with%20colorful%20comic%20page%20elements%20floating%2C%20warm%20golden%20and%20coral%20tones%2C%20modern%20manga%20aesthetic%20with%20clean%20graphic%20design%20feel&width=600&height=400&seq=cards-new-04&orientation=landscape',
  },
  {
    title: '完结神作补番',
    desc: '不可错过的已完结经典漫画全集免费看，一次性追完过足瘾。',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20warm-toned%20illustration%20of%20stacked%20manga%20volumes%20with%20golden%20hour%20lighting%2C%20vintage%20Japanese%20comic%20aesthetic%2C%20cozy%20reading%20atmosphere%20with%20soft%20shadows&width=600&height=400&seq=cards-classic-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            追更推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            编辑精心整理的连载漫画推荐，发现你的下一部追更漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {cardsData.map((card) => (
            <div
              key={card.title}
              className="bg-background-100 rounded-xl overflow-hidden hover:scale-[1.02] transition-transform cursor-pointer group"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-secondary-500/90 text-background-50 text-[11px] font-semibold">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-800 mb-2">{card.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}